import DashboardPage from "@/pages/Dashboard";

export default [
  {
    path: "/projectpricing/:projectid",
    name: "ProjectPricingPage",
    component: DashboardPage,
    props: { dashboardPage: "project-pricing", headerMode: "partial_limited" }
  },
  {
    path: "/projecttasks/:projectid",
    name: "ProjectTasksPage",
    component: DashboardPage,
    props: { dashboardPage: "project-tasks", headerMode: "partial_limited" }
  },
  {
    path: "/projectphases/:projectid",
    name: "ProjectPhasesPage",
    component: DashboardPage,
    props: { dashboardPage: "project-phases", headerMode: "partial_limited" }
  },
  {
    path: "/projecttotals/:projectid",
    name: "ProjectTotalsPage",
    component: DashboardPage,
    props: { dashboardPage: "project-totals", headerMode: "partial_limited" }
  }
];
